import { render, staticRenderFns } from "./BreadcrumbButton.component.vue?vue&type=template&id=aa61c676&scoped=true&"
import script from "./BreadcrumbButton.component.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbButton.component.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbButton.component.vue?vue&type=style&index=0&id=aa61c676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa61c676",
  null
  
)

export default component.exports